var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('pulse-loader',{attrs:{"color":'#448AFF',"size":'20px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }